import {
  DecodedValueMap,
  QueryParamConfigMap,
  SetQuery,
} from 'use-query-params'
import { SuiteParam } from './suiteParam'

export const sharedQueryParams = {
  suite: SuiteParam,
}

export interface DashboardParamsState<T extends QueryParamConfigMap> {
  query: DecodedValueMap<T>
  setQuery: SetQuery<T>
}
